"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _frameTokens = _interopRequireDefault(require("./frameTokens"));
var _jsxRuntime = require("react/jsx-runtime");
var FrameWrapper = _styledComponents.default.div.withConfig({
  displayName: "Frame__FrameWrapper",
  componentId: "sc-1xnkzxu-0"
})(["padding:", ";background:", ";border-style:solid;border-width:", ";border-color:", ";border-radius:", ";min-height:", ";", ";"], _tokens.default.sky.sys.spacing['300'], _tokens.default.sky.sys.color.background.neutral['2'], _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative, _tokens.default.sky.sys.size.borderradius['3'], function (_ref) {
  var _sizes$verticalSize$h;
  var height = _ref.height;
  return height ? (_sizes$verticalSize$h = _frameTokens.default.verticalSize[height]) === null || _sizes$verticalSize$h === void 0 ? void 0 : _sizes$verticalSize$h.height : 'auto';
}, function (_ref2) {
  var centerContent = _ref2.centerContent;
  return centerContent && "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  ";
});
var Frame = function Frame(_ref3) {
  var height = _ref3.height,
    _ref3$centerContent = _ref3.centerContent,
    centerContent = _ref3$centerContent === void 0 ? false : _ref3$centerContent,
    children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FrameWrapper, {
    height: height,
    centerContent: centerContent,
    children: children
  });
};
var _default = exports.default = Frame;